import { render } from "./SpellingGameEnd.vue?vue&type=template&id=4b1e93d8&ts=true"
import script from "./SpellingGameEnd.vue?vue&type=script&lang=ts"
export * from "./SpellingGameEnd.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__